import Vue from "vue";

import ProfileAvatar from "./profile-avatar.vue";
import RatingCircle from "./rating-circles/rating-circle-legacy.vue";
import MediumIcon from "./medium-icon.vue";

import ReviewTile from "./review-tile.vue";

import SearchResults from "./search/search-results.vue";
import SearchTile from "./search/search-tile.vue";
import SearchBar from "./search/search-bar.vue";

Vue.component("profile-avatar", ProfileAvatar);
Vue.component("rating-circle", RatingCircle);
Vue.component("medium-icon", MediumIcon);

Vue.component("review-tile", ReviewTile);

Vue.component("search-results", SearchResults);
Vue.component("search-tile", SearchTile);
Vue.component("search-bar", SearchBar);
